var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-24",
    "data-name": "50_Kids_Icons-24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M80,40.285A40,40,0,1,1,40.284,0,40,40,0,0,1,80,40.285Z",
    transform: "translate(0 0)",
    fill: "#704d70"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4427",
    "data-name": "Group 4427",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M141.759,232.491c1.13,2.677.515,5.278-1.374,5.81s-4.337-1.205-5.467-3.882-.515-5.278,1.374-5.811S140.629,229.815,141.759,232.491Z",
    transform: "translate(-113.359 -192.808)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M325.934,232.491c-1.13,2.677-.514,5.278,1.375,5.81s4.337-1.205,5.466-3.882.515-5.278-1.374-5.811S327.065,229.815,325.934,232.491Z",
    transform: "translate(-274.53 -192.808)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4428",
    "data-name": "Group 4428",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 19.811,
    cy: 18.135,
    rx: 19.811,
    ry: 18.135,
    transform: "translate(20.092 8.732)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4429",
    "data-name": "Group 4429",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M114.694,415.249l-.009-.145c0-8.821-3.3-17.367-7.334-18.995l-17.171-6.918a22.748,22.748,0,0,0-14.668-.019l-17.417,6.959c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145Z",
    transform: "translate(-42.819 -327.347)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4430",
    "data-name": "Group 4430",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M223.379,266.134a6.856,6.856,0,0,1-6.856,6.856h-.831a6.856,6.856,0,0,1-6.856-6.856v-17.66a6.856,6.856,0,0,1,6.856-6.856h.831a6.856,6.856,0,0,1,6.856,6.856Z",
    transform: "translate(-176.205 -203.865)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4432",
    "data-name": "Group 4432",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4431",
    "data-name": "Group 4431",
    transform: "translate(25.631 13.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M193.549,118.91a11.37,11.37,0,0,1-11.37,11.37h-6.771a11.37,11.37,0,0,1-11.37-11.37V99.866a11.37,11.37,0,0,1,11.37-11.37h6.771a11.37,11.37,0,0,1,11.37,11.37Z",
    transform: "translate(-164.039 -88.496)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4433",
    "data-name": "Group 4433",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(32.539 36.964)",
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(43.853 36.964)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4434",
    "data-name": "Group 4434",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M161.839,73.272c-9.566,0-17.321,8.405-17.321,18.774a19.9,19.9,0,0,0,2.349,9.444l1.721-14.6h26.5l1.724,14.6a19.9,19.9,0,0,0,2.348-9.444C179.16,81.677,171.405,73.272,161.839,73.272Z",
    transform: "translate(-121.937 -61.823)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4435",
    "data-name": "Group 4435",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M242.619,268.928a2.628,2.628,0,0,1-5.13.593,2.782,2.782,0,0,0-.126.783,2.814,2.814,0,1,0,5.629,0A2.776,2.776,0,0,0,242.619,268.928Z",
    transform: "translate(-200.275 -226.908)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4436",
    "data-name": "Group 4436",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M114.685,429.37c0-8.821-3.3-17.367-7.334-18.995l-13.653-5.5a12.058,12.058,0,0,1-21.928.058L58.094,410.4c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145h63.946Z",
    transform: "translate(-42.819 -341.613)",
    fill: "#43b06d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4437",
    "data-name": "Group 4437",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M170.28,93.644l-1.29-4.383L150.809,102.5v8.97l11.358-2.813C168.618,107.058,172.25,100.337,170.28,93.644Z",
    transform: "translate(-127.245 -75.314)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4438",
    "data-name": "Group 4438",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M287.616,134.707c-.011-4.351-1.357-8.559-2.978-12.688a7.753,7.753,0,1,0,2.978,12.688Z",
    transform: "translate(-231.431 -102.576)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4440",
    "data-name": "Group 4440",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4439",
    "data-name": "Group 4439",
    transform: "translate(33.078 47.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M211.7,302.509c0,.032,0,.068,0,.1a5.924,5.924,0,1,0,11.847,0c0-.034,0-.07,0-.1Z",
    transform: "translate(-211.697 -302.509)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M223.746,302.509v.507a1.86,1.86,0,0,0,1.86,1.862H231.7a1.861,1.861,0,0,0,1.863-1.862v-.507Z",
    transform: "translate(-221.863 -302.509)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443",
    transform: "translate(26.32 35.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4441",
    "data-name": "Group 4441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M178.1,233.7h-6.974a2.679,2.679,0,0,1-2.676-2.676v-3.016a2.68,2.68,0,0,1,2.676-2.676H178.1a2.679,2.679,0,0,1,2.676,2.676v3.016A2.679,2.679,0,0,1,178.1,233.7Zm-6.974-7.163a1.472,1.472,0,0,0-1.47,1.47v3.016a1.472,1.472,0,0,0,1.47,1.47H178.1a1.472,1.472,0,0,0,1.471-1.47v-3.016a1.472,1.472,0,0,0-1.471-1.47Z",
    transform: "translate(-168.449 -225.333)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442",
    transform: "translate(14.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M273.4,233.7h-6.974a2.679,2.679,0,0,1-2.676-2.676v-3.016a2.68,2.68,0,0,1,2.676-2.676H273.4a2.679,2.679,0,0,1,2.676,2.676v3.016A2.68,2.68,0,0,1,273.4,233.7Zm-6.974-7.163a1.472,1.472,0,0,0-1.47,1.47v3.016a1.472,1.472,0,0,0,1.47,1.47H273.4a1.472,1.472,0,0,0,1.47-1.47v-3.016a1.472,1.472,0,0,0-1.47-1.47Z",
    transform: "translate(-263.751 -225.333)",
    fill: "#3d2a3d"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1159",
    "data-name": "Rectangle 1159",
    width: 3.618,
    height: 1.378,
    transform: "translate(38.12 38.84)",
    fill: "#3d2a3d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.bbb5d4c60e92eeef25e69c84b1bb62f3.svg";
export { ForwardRef as ReactComponent };